import Vue from 'vue';
import VeeValidate from 'vee-validate';
import PhoneNumber from 'awesome-phonenumber';
import it from "vee-validate/dist/locale/it";
import de from "vee-validate/dist/locale/de";
import en from "vee-validate/dist/locale/en";
import fr from "vee-validate/dist/locale/fr";
import i18n from './locale'
import {checkVAT, countries} from 'jsvat';
import CodiceFiscale from "codice-fiscale-js";

export const eu_country_codes = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HU', 'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];


// @todo lazy loading dei dizionari
Vue.use(VeeValidate, {
    //i18nRootKey: 'validations',
    i18n,
    dictionary: {
        it: {
            messages: {
                ...it.messages,
                mindimension: `Le dimensioni del file devono essere almeno {1}px per {2}px`,
                iban: `Inserisci un IBAN valido`,
                iban_it: `Inserisci un IBAN italiano valido`,
            }
        },
        de,
        en: {
            messages: {
                ...en.messages,
                mindimension: `The file dimensions must be greater {1}px by {2}px`,
                iban: `Insert a valid IBAN`,
                iban_it: `Insert a valid Italian IBAN`,
            }
        },
        fr
    },
    fieldsBagName: 'veeFields',
    errorBagName: 'veeErrors'
});

Vue.mixin({
    methods: {
        validationState: function(field) {
            if (
                this.veeFields[field] &&
                (this.veeFields[field].dirty || this.veeFields[field].validated)
            ) {
                return !this.veeErrors.has(field)
            }
            return null
        }
    }
})

VeeValidate.Validator.extend('phoneNumber', {
    getMessage: () => `Insert a valid phone number`,
    validate (value) {
        return new Promise(resolve => {
            let phone = new PhoneNumber(value);
            resolve({ valid: phone.isValid() })
        })
    }
});

VeeValidate.Validator.extend('vatNumberGlobal', {
  getMessage: () => `Insert a valid vat number`,
  validate (value, [country]) {
    return new Promise(resolve => {
      if(eu_country_codes.includes(country.toUpperCase())) {
        let vatResult = checkVAT(value, countries);
        resolve({ valid: vatResult.isValid })
      }

      resolve({ valid: true });
    })
  }
});

VeeValidate.Validator.extend('vatNumberByCountry', {
  getMessage: () => `Insert a valid vat number`,
  validate (value, [country]) {
    return new Promise(resolve => {
      if(eu_country_codes.includes(country.toUpperCase())) {
        let vatResult = checkVAT(value, countries.filter(c => c.codes[0] === country));
        resolve({ valid: vatResult.isValid })
      }

      resolve({ valid: true });
    })
  }
});

VeeValidate.Validator.extend('vatNumber', {
    getMessage: () => `Insert a valid vat number`,
    validate (value) {
        return new Promise(resolve => {
            let vatResult = checkVAT(value, countries);
            resolve({ valid: vatResult.isValid })
        })
    }
});

VeeValidate.Validator.extend('itVatNumber', {
    getMessage: () => `Insert a valid vat number`,
    validate (value) {
        return new Promise(resolve => {
            let vatResult = checkVAT(`IT${value}`, countries);
            resolve({ valid: vatResult.isValid })
        })
    }
});

VeeValidate.Validator.extend('itCompanyFiscalCode', {
    getMessage: () => `Insert a valid fiscal code`,
    validate (value) {
        return new Promise(resolve => {
            try {
                const cf = new CodiceFiscale(value);
                resolve({ valid: true })
            } catch (e) {
                let vatResult = checkVAT(`IT${value}`, countries);
                resolve({ valid: vatResult.isValid })
            }
        })
    }
});

VeeValidate.Validator.extend('length2', {
    getMessage: () => `The {0} must be {1} characters.`,
    validate (value, [length]) {
        return new Promise(resolve => {
            resolve({ valid: value.length === +length});
        })
    }
});

VeeValidate.Validator.extend('fiscalCode', {
    getMessage: () => `Insert a valid fiscal code`,
    validate (value) {
        return new Promise(resolve => {
            try {
                const cf = new CodiceFiscale(value);
                resolve({ valid: true })
            } catch (e) {
                resolve({ valid: false })
            }
        })
    }
});

VeeValidate.Validator.extend('size', {
    getMessage: () => `The {0} size must be less than {2}`,
    validate (value, [raw_size]) {
        //console.log(raw_size);
        const size = Number(raw_size) * 1000;
        const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1000));
        const pretty = (((size / Math.pow(1000, i)).toFixed(2) * 1) + " " + (['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][i]));
        return new Promise(resolve => {
            resolve({
                valid: value.size <= size,
                data: value.size <= size ? undefined : pretty
            })
        })
    }
});

VeeValidate.Validator.extend('ratio', {
    getMessage: (field, { l = 4, h = 3 }) => {
        return `The {0} aspect ratio must be {1}:{2}`
    },
    validate (value, { l = 4, h = 3 }) {
        return new Promise(resolve => {
            const fr = new FileReader;
            fr.onload = function() { // file is loaded
                const img = new Image;
                img.onload = function() {
                    resolve({ valid: img.width/img.height === l/h })
                };
                img.src = fr.result; // is the data URL because called with readAsDataURL
            };
            fr.readAsDataURL(value);
        })
    }
}, { paramNames: ['l', 'h'] });

VeeValidate.Validator.extend('lte', {
    getMessage: () => `{0} must be lower or equal to {1}`,
    validate: (value, [otherValue]) => {
        return new Promise(resolve => {
            if (!otherValue) resolve({ valid: null });
            resolve({ valid: +value <= +otherValue, data: {} })
        })
    }
}, { hasTarget: true });


VeeValidate.Validator.extend('gte', {
    getMessage: () => `{0} must be greater or equal to {1}`,
    validate: (value, [otherValue]) => {
        return new Promise(resolve => {
            if (!otherValue) resolve({ valid: null });
            resolve({ valid: +value >= +otherValue, data: {} })
        })
    }
}, { hasTarget: true });

VeeValidate.Validator.extend('ltei', {
    getMessage: () => `{0} must be lower or equal to {1}`,
    validate: (value, [otherValue]) => {
        return new Promise(resolve => {
            if (!otherValue && otherValue !== 0) resolve({ valid: null });
            if (+otherValue === 0) resolve(true);
            resolve({ valid: +value <= +otherValue, data: {} })
        })
    }
}, { hasTarget: true });


VeeValidate.Validator.extend('gtei', {
    getMessage: () => `{0} must be greater or equal to {1}`,
    validate: (value, [otherValue]) => {
        return new Promise(resolve => {
            if (!otherValue && otherValue !== 0) resolve({ valid: null });
            if (+value === 0) resolve(true);
            resolve({ valid: +value >= +otherValue, data: {} })
        })
    }
}, { hasTarget: true });

VeeValidate.Validator.extend('mindimension', {
    getMessage: () => `The file dimensions must be greater {1}px by {2}px`,
    validate(file, [width, height]) {
        return new Promise(resolve => {
            const image = new Image();
            image.onerror = () => resolve({ valid: false });
            image.onload = () => resolve({
                valid: image.width >= Number(width) && image.height >= Number(height)
            });

            image.src = URL.createObjectURL(file);
        });
    }
}, { hasTarget: true });


VeeValidate.Validator.extend('iban', {
  getMessage: () => 'Insert a valid IBAN',
  validate(value) {
    return /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/i.test(value.replace(/\s+/g, ''));
  }
});

VeeValidate.Validator.extend('iban_it', {
  getMessage: () => 'Inserisci un IBAN italiano valido',
  validate(value) {
    const iban = value.replace(/\s+/g, '').toUpperCase();

    return /^IT\d{2}[A-Z]\d{5}\d{5}[0-9A-Z]{12}$/.test(iban);
  }
});
